import React from 'react';
import { Shield, ExternalLink } from 'lucide-react';

interface VerifiedBadgeProps {
  clinicianId: string;
  name: string;
  verificationDate: string;
  size?: 'small' | 'medium' | 'large';
}

export const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({
  clinicianId,
  name,
  verificationDate,
  size = 'medium',
}) => {
  const sizeClasses = {
    small: 'h-16 text-xs',
    medium: 'h-20 text-sm',
    large: 'h-24 text-base',
  };

  return (
    <a
      href={`https://therapydirect.org/verify/${clinicianId}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center ${sizeClasses[size]} px-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow`}
    >
      <div className="flex items-center space-x-3">
        <Shield className="h-8 w-8 text-purple-600" />
        <div>
          <div className="font-semibold text-gray-900">Verified Provider</div>
          <div className="text-gray-500">TherapyDirect.org</div>
        </div>
        <ExternalLink className="h-4 w-4 text-gray-400" />
      </div>
    </a>
  );
};